let CarouselSegmentos = (function(){
	var slider 			= $('#carousel-segmentos');
	var carouselItem 	= $('#carousel-segmentos .carousel-item');
	var itensLength 	= carouselItem.length;

	carouselItem.each(function(index, el){

		var prevItem  = $(this).prev();
		var nextItem  = $(this).next();

		if(index == 0){
			prevItem = $('#carousel-segmentos .carousel-item:last-child');
		}

		if (index == (itensLength - 1)){
			nextItem = $('#carousel-segmentos .carousel-item:first-child');
		}

		var prev = prevItem.find('.segmento:not(.clone)').clone().addClass('clone prev');
		var next = nextItem.find('.segmento:not(.clone)').clone().addClass('clone next');

		$(this).find('.line').append(prev,next);
	});

	$('#carousel-segmentos .clone.prev').click(function(){
		slider.carousel('prev');
	});

	$('#carousel-segmentos .clone.next').click(function(){
		slider.carousel('next');
	});

})();